import styles from "./card-ribbon.module.scss";

function CardRibbon({ text = "" }) {
  const x = 60 / (text.length / 2);
  return (
    <svg
      width="76px"
      height="76px"
      viewBox="0 0 76 76"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={styles.ribbon}
    >
      <g
        id="Account-Dashboard---Personal-Loans"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Personal-Loans" transform="translate(-687.000000, -402.000000)">
          <g id="pl_lfs-03" transform="translate(408.000000, 402.000000)">
            <g id="ribbon_closed" transform="translate(279.000000, 0.000000)">
              <polygon
                id="Path"
                fill="#E02020"
                points="76 44.8873016 76 76 0 5.68434189e-14 31.1126984 5.68434189e-14"
              />
              <path
                d="M-2.13162821e-14,2.84217094e-14 L5,5 L-2.13162821e-14,5 L-2.13162821e-14,8.52651283e-14 Z"
                id="Combined-Shape"
                fill="#860000"
              />
              <path
                d="M71,71 L76,76 L71,76 L71,71 Z"
                id="Combined-Shape"
                fill="#860000"
              />
              <text
                id="CLOSED"
                transform="translate(45.334524, 35) rotate(45.000000) translate(-45.334524, -35)"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="12"
                fontWeight="bold"
                line-spacing="22"
                letterSpacing="-0.072"
                fill="#FFFFFF"
              >
                <tspan x={x} y="35">
                  {text.toUpperCase()}
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export { CardRibbon };
